// *******************************************************************************
// Special Notification
// *******************************************************************************

const toggleModal = (element, toggle) => {
  element.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

// Close Modal
attachEvent('.special-notification__close, .special-notification__overlay', 'click', (ev) => {
  const parentElem = ev.target.closest('.special-notification');
  toggleModal(parentElem, false);
  ev.preventDefault();
});

// Open Modal
attachEvent('.special-notification__trigger', 'click', (ev) => {
  const modal = document.querySelector('.special-notification');
  toggleModal(modal, true);
  ev.preventDefault();
});

if (document.querySelector('.special-notification.is-open-modal')) {
  document.body.classList.add('body-scroll-locked');
}
